const apiUrl = import.meta.env.VITE_API_URL;
const appUrl = import.meta.env.VITE_APP_URL;


// CORE
export const loginUrl  = `${apiUrl}/auth/login?redirect_to=${appUrl}`;
export const logoutUrl = `${apiUrl}/auth/logout`;
export const userMeUrl = `${apiUrl}/user/me`;

export const getProjectsUrl = `${apiUrl}/core/projects/get-projects`;
export const addNewProjectUrl = `${apiUrl}/core/projects/add-new-project`;


// UTILS
export const utilsCsvPreviewUrl = `${apiUrl}/drillholes/utils/csv-preview`;
export const utilsExcelSheetsUrl = `${apiUrl}/drillholes/utils/excel-sheets`;
export const utilsExcelPreviewUrl = `${apiUrl}/drillholes/utils/excel-preview`;
export const availableParametersUrl    = `${apiUrl}/drillholes/utils/available-parameters`;


// DRILLHOLES
export const collarsUrl = `${apiUrl}/drillholes/collars`;
export const uploadCollarsUrl = `${apiUrl}/drillholes/collars/upload-csv`;
export const collarsColumnMappingUrl = `${apiUrl}/drillholes/collars/column-mapping`;
export const uploadCollarsExcelUrl = `${apiUrl}/drillholes/collars/upload-excel`;

export const surveysUrl = `${apiUrl}/drillholes/surveys`;
export const uploadSurveysUrl = `${apiUrl}/drillholes/surveys/upload-csv`;
export const surveysColumnMappingUrl = `${apiUrl}/drillholes/surveys/column-mapping`;
export const uploadSurveysExcelUrl = `${apiUrl}/drillholes/surveys/upload-excel`;

export const drillholesUrl = `${apiUrl}/drillholes/drillholes`;
export const drillholeTracesUrl = `${apiUrl}/drillholes/traces`;

export const intervalsUrl = `${apiUrl}/drillholes/intervals`;
export const uploadIntervalsUrl        = `${apiUrl}/drillholes/intervals/upload-csv`;
export const uploadIntervalsExcelUrl   = `${apiUrl}/drillholes/intervals/upload-excel`;

export const intervalColumnKeysUrl     = `${apiUrl}/drillholes/intervals/column-keys`;
export const intervalLogFilesUrl      = `${apiUrl}/drillholes/intervals/log-files`;
export const intervalDeleteLogFileUrl = `${apiUrl}/drillholes/intervals/log-file`;

export const setParametersMappingUrl     = `${apiUrl}/drillholes/intervals/set-parameters-mapping`;
export const getHoleDefinedParametersUrl = `${apiUrl}/drillholes/get-hole-defined-parameters`;


export const histogramUrl = (parameterId: string) => `${apiUrl}/drillholes/intervals/histogram/${parameterId}`;
export const correlationUrl = `${apiUrl}/drillholes/intervals/correlation`;

export const uploadGeometryUrl = `${apiUrl}/geometries/upload-geometry`;



